// @ts-check

/** @type {number} */
export const PLAYLIST_TITLE_MIN = 3
/** @type {number} */
export const PLAYLIST_TITLE_MAX = 100
/** @type {number} */
export const PLAYLIST_DEFAULT_MAX_LISTS = 3
/** @type {number} */
export const PLAYLIST_PRO_MAX_LISTS = 1000
/** @type {number} */
export const PLAYLIST_DEFAULT_MAX_PEOPLE = 20
/** @type {number} */
export const PLAYLIST_PRO_MAX_PEOPLE = 200
/** @type {number} */
export const PLAYLIST_DEFAULT_MAX_SHARES = 3
/** @type {number} */
export const PLAYLIST_PRO_MAX_SHARES = 25
/** @type {string} */
export const VITE_PROSEARCH_VERSION = "v5.0.46"; // 'not set'
/** @type {number} */
export const BIO_TEXT_MAX_LENGTH = 3048

/** @type {RegExp} */
export const EMAIL_REGEX_PATTERN =
  /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+...)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i

/** @type {RegExp} */
export const PHONE_REGEX_PATTERN = /^\+?[0-9.() -]{7,32}$/
